import type { TransactionsFilterState } from '../../../types/dashboardV2';
import type { MobileTransactionsFilterState } from '../../../types/mobileFilterSheetTypes';

/** Page filters -> mobile-sheet draft (drops `search`; '' status -> null). */
export const toMobileTransactionsFilters = (
  filters: TransactionsFilterState,
): MobileTransactionsFilterState => ({
  status: filters.status || null,
  dateRange: filters.dateRange,
  minAmount: filters.minAmount,
  maxAmount: filters.maxAmount,
  refundState: filters.refundState,
});

/** Mobile-sheet draft -> page filter updates (null status -> ''). */
export const fromMobileTransactionsFilters = (
  mobile: MobileTransactionsFilterState,
): Partial<TransactionsFilterState> => ({
  status: mobile.status ?? '',
  dateRange: mobile.dateRange,
  minAmount: mobile.minAmount,
  maxAmount: mobile.maxAmount,
  refundState: mobile.refundState,
});
